import { createAction } from 'redux-actions';

export const setIsLoading = createAction('SET_IS_LOADING');
export const setErrorMessage = createAction('SET_ERROR_MESSAGE');
export const toggleAlert = createAction('TOGGE_ALEART');
export const setAlert = createAction('SET_ALEART');
export const setProgress = createAction('SET_PROGRESS');
export const setPause = createAction('SET_PAUSE');

export const SAGA_START_PROGRESS = 'SAGA_START_PROGRESS';
export const SAGA_PAUSE_PROGRESS = 'SAGA_PAUSE_PROGRESS';
export const SAGA_RESUME_PROGRESS = 'SAGA_RESUME_PROGRESS';
export const SAGA_CANCEL_PROGRESS = 'SAGA_CANCEL_PROGRESS';
